import { createFileRoute } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'

/**
 * /notice — 자사몰 사관학교 비수강생이 솔루션 진입을 시도했을 때 보여줄 안내.
 *
 * install-not-eligible / no-linked-mall 과 동일한 톤 (로고 + 한 단락 본문 +
 * 캠퍼스 브랜드 컬러 CTA).
 */
export const Route = createFileRoute('/notice')({
  component: NoticePage,
  validateSearch: (search) => ({
    mall_id: (search.mall_id as string) || '',
  }),
})

/** 캠퍼스 홈 — 환경변수 미설정 시 dev 도메인 fallback. */
const CAMPUS_URL =
  import.meta.env.VITE_CAMPUS_URL || 'https://dev.1bpluschool.com'

function NoticePage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface px-4 py-8">
      <div className="max-w-lg w-full bg-surface-lowest rounded-2xl border border-border p-6 sm:p-8">
        {/* 헤더 */}
        <div className="text-center mb-6">
          <img
            src="/images/onebplus_logo.svg"
            alt="자사몰 사관학교 솔루션"
            className="mx-auto mb-4 h-10"
          />
          <h1 className="text-lg font-bold text-on-surface mb-2">
            자사몰 사관학교 수강생만 이용할 수 있어요
          </h1>
          <p className="text-sm text-on-surface-variant leading-relaxed">
            본 솔루션은{' '}
            <span className="font-semibold text-on-surface">
              자사몰 사관학교
            </span>{' '}
            수강생 전용 도구예요. 자사몰 사관학교에 등록한 뒤 다시 시도해주세요.
          </p>
        </div>

        {/* CTA — 자사몰 사관학교 캠퍼스 BI 메인 컬러 (#ff5757) — campus 의 globals.css 와 동기화.
            사용자가 가게 될 곳(캠퍼스)의 브랜드 컬러를 그대로 사용해 "어디로 가는 버튼인지"
            시각적으로 명시. 솔루션 design token 대신 raw hex 사용. */}
        <a
          href={CAMPUS_URL}
          className="flex items-center justify-center gap-2 w-full rounded-lg bg-[#ff5757] text-white py-2.5 text-sm font-medium hover:bg-[#ff5757]/90 transition-colors"
        >
          자사몰 사관학교 이동하기
          <ArrowRight className="h-4 w-4" />
        </a>
      </div>
    </div>
  )
}
